var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5V6.5C0 7.33 0.67 8 1.5 8H6.5C7.33 8 8 7.33 8 6.5V1.5C8 0.67 7.33 0 6.5 0H1.5C0.67 0 0 0.67 0 1.5ZM2 2H6V6H2V2ZM0 16.5C0 17.33 0.67 18 1.5 18H6.5C7.33 18 8 17.33 8 16.5V11.5C8 10.67 7.33 10 6.5 10H1.5C0.67 10 0 10.67 0 11.5V16.5ZM2 12H6V16H2V12ZM16.5 0H11.5C10.67 0 10 0.67 10 1.5V6.5C10 7.33 10.67 8 11.5 8H16.5C17.33 8 18 7.33 18 6.5V1.5C18 0.67 17.33 0 16.5 0ZM16 6H12V2H16V6ZM10 10H12V12H10V10ZM12 12H14V14H12V12ZM10 14H12V16H10V14ZM14 14H16V16H14V14ZM16 16H18V18H16V16ZM12 16H14V18H12V16ZM14 10H16V12H14V10ZM16 12H18V14H16V12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOn);
export default __webpack_public_path__ + "static/media/add-on.e2d5bfd5d0230177692d868cc4e790df.svg";
export { ForwardRef as ReactComponent };